"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
// ACL support classes
const acl_classes_1 = require("./acl.classes");
const Constants_1 = require("../Constants");
const file_data_service_1 = require("../../v2/commons/file-data.service");
const identify_interface_1 = require("@src/app/xs/interfaces/identify.interface");
const i0 = require("@angular/core");
const i1 = require("../../v2/commons/file-data.service");
class AclService {
    // it begins
    constructor(v2FileService) {
        this.__ID = null;
        this.debug = Constants_1.Constants.debug_off;
        this.debugPrimary = Constants_1.Constants._red;
        this.debugSecondary = Constants_1.Constants._red;
        // identifier
        this.id = '';
        // static until later when we hook it into the backend
        this.isReady = false;
        // resource and rule collections
        this.collections = null;
        // for global support for changing the current role
        this.roleSelected = '';
        // save original / actual role in the system
        this.roleActual = null;
        // sharable lists (global roles [for admin and config] and a users roles [for context switching])
        this.allRoles = null;
        this.myRoles = null;
        // access object (in both directions)
        this.access = null;
        this.access_inv = null;
        this.can = null;
        this.can_i = null;
        // two lists of the same resources->features in true and false state (used for quickly filling lists with default values)
        this.idx_false = null;
        this.idx_true = null;
        // index of groups (array of resources)
        this.idx_group = null;
        // index of defaults
        this.defaults = null;
        // Observable string sources
        this.accessUpdateSource = new rxjs_1.Subject();
        // Observable string streams
        this.updatedAccess$ = this.accessUpdateSource.asObservable();
        if (this.debug) {
            console.log('%c ACL.service %c CONSTRUCTOR', this.debugPrimary, this.debugSecondary);
        }
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
        this.init('default');
        v2FileService.acl.state.subscribe(acls => {
            this.can = this.parseWidgets(acls);
            if (this.debug) {
                console.log('%c ACL.service %c -- acl.state.subscribe()', this.debugPrimary, this.debugSecondary, acls, this.can);
            }
            this.onAccessModelChange();
            /* let me = this;
            setTimeout ( () => {
              console.log ( '@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@');
              me.can['switch']['scene'] = false;
            }, 13000 ); */
        });
    }
    // Service message commands
    onAccessModelChange() {
        if (this.debug) {
            console.log('%c ACL.service %c onAccessModelChange()', this.debugPrimary, this.debugSecondary);
        }
        this.accessUpdateSource.next(null);
    }
    canI() {
        return this.can;
    }
    parseWidgets(acls = []) {
        let res = {};
        let res_inv = {};
        // console.log('#######ACL in',acls);
        acls.forEach(widget => {
            let features = widget.features;
            let key = widget.id;
            Object.keys(features).forEach(k => {
                let v = features[k];
                if (!res[k]) {
                    res[k] = {};
                }
                if (!res_inv[key]) {
                    res_inv[key] = {};
                }
                if (v == 'yes') {
                    res[k][key] = true;
                    res_inv[key][k] = true;
                }
                else {
                    res[k][key] = false;
                    res_inv[key][k] = false;
                }
            });
        });
        this.can = res;
        this.can_i = res_inv;
        // console.log('#######ACL out',res);
        return res;
    }
    init(id) {
        if (this.debug) {
            console.log('%c ACL.service %c init()', this.debugPrimary, this.debugSecondary, id);
        }
        // first time role selected is any / all / whatever (to be refined later)
        this.roleSelected = '*';
        if (!id) {
            id = 'default';
        }
        // identifier for this service
        this.id = id;
        // set up a collection Map
        this.collections = new Map();
        // create a default global collection
        this.addCollection('domain', [
            // UI
            { id: 'config', features: ['see_all_access'] },
            { id: 'toolbar', features: ['see', 'see_projects', 'see_explorer', 'see_menu_account', 'see_menu_user', 'see_progress', 'see_upload', 'test1', 'test2'] },
            // global accounts and profiles
            { id: 'account', features: ['create', 'edit', 'rename', 'delete', 'manage_users', 'manage_projects', 'manage_plan', 'manage_apis'] },
            { id: 'user', features: ['create', 'edit', 'rename', 'delete', 'manage_language'] },
            // basic entities
            { id: 'project', features: ['see', 'switch', 'create', 'rename', 'edit', 'share', 'delete', 'manage',
                    'upload_unsupported_files', 'upload_supported_files', 'download_unsupported_files', 'download_supported_files', 'download_tiles'] },
            { id: 'scene', features: ['see', 'switch', 'create', 'rename', 'edit', 'share', 'delete', 'reorder'] },
            { id: 'layer', features: ['see', 'toggle', 'create', 'rename', 'edit', 'share', 'delete', 'reorder', 'download', 'timeline', 'split_screen', 'height_adjust'] },
            // annotations (group enables us to treat all of these as one resource)
            { id: 'annotations', group: 'annotations', features: ['see', 'create_report', 'create',] },
            { id: 'pin', group: 'annotations', features: ['see', 'create', 'rename', 'edit', 'delete', 'edit_notes', 'see_notes', 'manage_screenshots', 'see_links', 'manage_links', 'see_properties', 'manage_properties'] },
            { id: 'line', group: 'annotations', features: ['see', 'create', 'rename', 'edit', 'delete'] },
            { id: 'area', group: 'annotations', features: ['see', 'create', 'rename', 'edit', 'delete'] },
            { id: 'volume', group: 'annotations', features: ['see', 'create', 'rename', 'edit', 'delete'] },
            { id: 'points', group: 'annotations', features: ['see', 'create', 'rename', 'edit', 'delete'] },
            // widgets and features
            { id: 'photogrammetry', group: 'costly', features: ['see', 'create'] },
            { id: 'terrain_compare', features: ['see', 'edit'] },
            { id: 'photos', features: ['see', 'edit'] },
            // widgets and features
            { id: 'plugin_agronomeye', group: 'special-plugins', features: ['see', 'see_sensors', 'edit_sensors', 'see_weather_stations', 'edit_weather_stations'] },
        ], [
            // domain admin can do it all
            { id: 'domain_admin', can: '*' },
            // account admin can do a bit less
            { id: 'account_admin', default_for: 'admin', can: '*', cannot: ['config:see_all_access', '@special-plugins:*', 'toolbar:test1'] },
            // project admin can do a bit less
            { id: 'project_admin', can: '*', default_for: 'user', cannot: ['config:*', 'project:create', 'project:delete', 'account:*', '@special-plugins:*', 'toolbar:see_menu_account,test1', '@costly:*'], },
            // normal user can do a lot of things
            /*
            { id: 'user',
              can: '*',
              cannot: [
                'config:*', 'account:*', 'user:*', '@special-plugins:*', '@costly:*', 'volume:*', 'terrain_compare:*',
                'toolbar:see_menu_account', 'toolbar:see_explorer', 'project:delete,manage', 'scene:delete,reorder' ], // but not these things
              but_can: [ 'user:edit,rename,manage_language' ]
            }, */
            // normal user can do a lot of things
            { id: 'processor',
                can: '*',
                cannot: [
                    'config:*', 'account:*', 'user:*', '@special-plugins:*', '@costly:*', 'volume:*', 'terrain_compare:*', 'annotations:see',
                    'toolbar:see_menu_account', 'toolbar:see_explorer', 'project:delete,manage', 'scene:delete,reorder'
                ],
                but_can: ['user:edit,rename,manage_language']
            },
            // normal user can do a lot of things
            { id: 'operator',
                can: '*',
                cannot: [
                    'config:*', 'account:*', 'user:*', '@special-plugins:*', '@costly:*', 'volume:*', 'terrain_compare:*', 'annotations:see',
                    'toolbar:see_menu_account', 'toolbar:see_explorer', 'project:delete,manage', 'scene:delete,reorder'
                ],
                but_can: ['user:edit,rename,manage_language']
            },
            // normal user can do a lot of things
            { id: 'surveyor',
                can: '*',
                cannot: [
                    'config:*', 'account:*', 'user:*', '@special-plugins:*', '@costly:*', 'volume:*', 'terrain_compare:*',
                    'toolbar:see_menu_account', 'toolbar:see_explorer', 'project:delete,manage', 'scene:delete,reorder'
                ],
                but_can: ['user:edit,rename,manage_language']
            },
            // normal user can do a lot of things
            { id: 'inspector',
                can: '*',
                cannot: [
                    'config:*', 'account:*', 'user:*', '@special-plugins:*', '@costly:*', 'volume:*', 'terrain_compare:*',
                    'toolbar:see_menu_account', 'toolbar:see_explorer', 'project:delete,manage', 'scene:delete,reorder'
                ],
                but_can: ['user:edit,rename,manage_language']
            },
            // clients can do even less
            { id: 'client',
                cannot: '*',
                can: [
                    'project:see,upload_unsupported_files,upload_supported_files,download_supported_files,download_unsupported_files',
                    'pin:*', 'line:*', 'area:*', 'volume:see', 'points:see',
                    'toolbar:*', 'scene:see', 'layer:see,split_screen,timeline', '@annotations:*',
                ],
                but_cannot: 'toolbar:see_menu_account,see_progress,see_explorer,see_upload'
            },
            // viewers even lessest ...
            { id: 'view_link',
                cannot: '*',
                can: [
                    'project:see', 'scene:see', 'layer:see', 'pin:see,see_notes'
                ],
            },
        ]);
        // default collections (so we get them in order)
        this.addCollection('account', [], []);
        this.addCollection('user', [], []);
        this.addCollection('project', [], []);
        this.isReady = true;
    }
    /* getters and setters */
    // getter setter for roleSelected
    getRoleSelected() {
        return this.roleSelected;
    }
    setRoleSelected(inp) {
        this.roleSelected = inp;
        if (!this.roleActual) {
            this.roleActual = inp;
        }
    }
    setRoleActual(inp) {
        this.roleActual = inp;
    }
    // get a collection as a JSON object (for saving/streaming)
    getCollectionObj(id) {
        let ret = {
            'id': id
        };
        let col = this.collections.get(id);
        if (col) {
            let re = [];
            for (const [res_id, res] of col.resources.entries()) {
                re.push(res.getItemObj());
            }
            ret['resources'] = re;
            let ro = [];
            for (const [rol_id, rol] of col.roles.entries()) {
                ro.push(rol.getItemObj());
            }
            ret['roles'] = ro;
            // console.log ( 'roles for '+id, ro);
        }
        return ret;
    }
    /* stack works */
    // add a collection to our stack
    addCollection(id, resources, roles) {
        if (this.debug) {
            console.log('ACL add collection "' + id + '"', resources, roles);
        }
        this.collections.set(id, new acl_classes_1.AclCollection(id, resources, roles));
    }
    // return the current list of default roles
    getDefaults() {
        if (!this.defaults) {
            this.getAllRoles();
        }
        return this.defaults;
    }
    // 
    // get all possible roles in our collection stack
    getAllRoles() {
        if (this.debug) {
            console.log(' - getAllRoles - ', this.roleSelected);
        }
        let ret = new Set();
        let defaults = new Map();
        let roleSelected = this.roleActual;
        // loop through all collections
        for (const [col_id, col] of this.collections.entries()) {
            // myLevel is if we're allowed to list roles "higher" than our current level
            let atMyLevel = roleSelected == '*' ? true : false;
            // temporary hack; allow access to all (unless role is specified)
            // if ( ! forRole ) {
            //   atMyLevel = true;
            // }
            // are there any defaults?
            if (col.defaults) {
                // reverse index of defaults ( old_role => new_role )
                Array.from(col.defaults.keys()).forEach(function (key) {
                    defaults.set(col.defaults.get(key), key);
                });
            }
            // return all roles from this collection
            Array.from(col.roles.keys()).forEach(function (key) {
                if (key == roleSelected) {
                    atMyLevel = true;
                }
                if (atMyLevel) {
                    ret.add(key);
                }
            });
        }
        this.defaults = defaults;
        // console.log ( 'getAllRoles done', ret);
        return ret;
    }
    // get only the roles from this.userSelected and down
    getRoles(forceAll = false) {
        // console.log ( 'getRoles');
        if (!this.allRoles) {
            this.allRoles = this.getAllRoles();
        }
        let ret = new Set(this.allRoles);
        // console.log ( 'getRoles cloned', this.allRoles, ret);
        if (forceAll) {
            return ret;
        }
        this.allRoles = ret;
        // make mods here based on your cascading role level
        return ret;
    }
    // get a list of all resources on our stack
    getResources() {
        let ret = new Set();
        for (const [col_id, col] of this.collections.entries()) {
            let keys = Array.from(col.resources.keys());
            keys.forEach(function (item) {
                ret.add(item);
            });
        }
        return ret;
    }
    // get all features for a resource
    getFeatures(resource) {
        let ret = new Set();
        // loop through their feature list
        for (const [fea_id, fea] of resource.features.entries()) {
            ret.add(fea);
        }
        return ret;
    }
    // get all the features from all our resources on our stack
    getAllFeatures() {
        let ret = new Set();
        // loop through all collections
        for (const [col_id, col] of this.collections.entries()) {
            // loop through their resources
            for (const [res_id, res] of col.resources.entries()) {
                // loop through their feature list
                for (const [fea_id, fea] of res.features.entries()) {
                    ret.add(fea);
                }
            }
        }
        return ret;
    }
    /* actions */
    // create a shell access object with all resources and features
    createAccessResources() {
        // return object
        let ret = {};
        // internal reverse index
        let idx_false = {};
        let idx_true = {};
        this.idx_group = new Map();
        // loop through all collections
        for (const [col_id, col] of this.collections.entries()) {
            // loop through their resources
            for (const [res_id, res] of col.resources.entries()) {
                if (res.group !== '') {
                    if (!this.idx_group.has(res.group)) {
                        this.idx_group.set(res.group, new Set());
                    }
                }
                // loop through their feature list
                for (const [fea_id, fea] of res.features.entries()) {
                    if (res.group !== '') {
                        const g = this.idx_group.get(res.group);
                        if (g) {
                            // console.log ( "!!!", g );
                            g.add(res_id);
                        }
                    }
                    // feature level ret
                    if (!ret[fea]) {
                        ret[fea] = {};
                    }
                    // resource level ret
                    if (!ret[fea][res_id]) {
                        ret[fea][res_id] = {};
                    }
                    // feature level idx
                    if (!idx_false[res_id]) {
                        idx_false[res_id] = {};
                        idx_true[res_id] = {};
                    }
                    // resource level idx
                    if (!idx_false[res_id][fea]) {
                        idx_false[res_id][fea] = {};
                        idx_true[res_id][fea] = {};
                    }
                    // default is that no one has access to anything (closed world)
                    ret[fea][res_id] = false;
                    idx_false[res_id][fea] = false;
                    idx_true[res_id][fea] = true;
                }
            }
        }
        this.idx_false = idx_false;
        this.idx_true = idx_true;
        return ret;
    }
    // parse a line of access rules into a object structure
    parseAccessSection(list, access) {
        // return object
        let ret = {};
        // go through the list of inputs
        for (var i = 0; i < list.length; i++) {
            // pick each item out
            const item = list[i];
            // pick the first token
            let first = this.alwaysArray(item.split(':'));
            // resource is always the first thing parsed
            let resource = first[0];
            let resources = [];
            // if this 'resource' is a group, we are dealing with multiple resources at a time
            if (resource.charAt(0) == '@') {
                // what's the group name?
                let group = resource.split('@').pop();
                // list of resources in this group
                resources = Array.from(this.idx_group.get(group).values());
            }
            else {
                // no, just a single resource
                resources.push(resource);
            }
            // more than one? That's most items
            if (first.length > 1) {
                // features are a comma-separated list
                let features = first[1].split(",").map((item) => item.trim());
                // make sure we've got no undefined resources
                resources.forEach(function (r) {
                    if (!ret[r]) {
                        ret[r] = {};
                    }
                });
                // for all features
                for (var j = 0; j < features.length; j++) {
                    // if a wildcard is given (meaning all features for this resource)
                    if (features[j] == '*') {
                        // using open / true or closed / false models
                        if (access) {
                            resources.forEach(function (r) {
                                // console.log ( ' -- resource (t) set', access, r, this.idx_true[r] );
                                ret[r] = this.idx_true[r];
                            }, this);
                        }
                        else {
                            resources.forEach(function (r) {
                                // console.log ( ' -- resource (f) set', access, r, this.idx_false[r] );
                                ret[r] = this.idx_false[r];
                            }, this);
                        }
                        // or just go through the list of features specifically
                    }
                    else {
                        resources.forEach(function (r) {
                            // console.log ( ' -- resource (r) set', access, r );
                            ret[r][features[j]] = access;
                        });
                    }
                }
            }
            else {
                // just one usually means we've passed in an asterisk '*' for selecting all resources
                if (item === '*') {
                    // console.log ( ' -- all resources set to access', access );
                    if (access) {
                        ret = this.idx_true;
                    }
                    else {
                        ret = this.idx_false;
                    }
                }
            }
        }
        return ret;
    }
    // parse and merge an access object out of all our stack (collections)
    getAccess(what_role = 'user', update = false) {
        if (this.debug) {
            console.log('%c ACL.service %c getAccess()', this.debugPrimary, this.debugSecondary, what_role, update);
        }
        // quick access to the cached access object
        if (this.access && !update) {
            if (this.debug) {
                console.log('ACL return cached', this.access);
            }
            return this.access;
        }
        if (what_role == '*') {
            what_role = this.roleSelected;
        }
        if (this.debug) {
            console.log('ACL getAccess', what_role, update);
        }
        this.allRoles = null;
        // convert role or roles into the same array for processing
        let roles = this.alwaysArray(what_role.split(",").map((item) => item.trim()));
        // create an object with all resources and features
        let access = this.createAccessResources();
        // deep clone (stupid JS has no deep cloning, so we use this JSON hack ...)
        let access_inv = JSON.parse(JSON.stringify(this.idx_false));
        // loop through all collections
        for (const [col_id, col] of this.collections.entries()) {
            roles.forEach(function (process_role) {
                if (this.debug) {
                    console.log('checking collection [' + col_id + '] for [' + process_role + ']', col);
                }
                // special rule; user collections only has rules for the one user, ie. the '*' role
                if (col_id == 'user') {
                    process_role = '*';
                }
                // check for the role in question
                if (col.roles.has(process_role)) {
                    const role = col.roles.get(process_role);
                    let process = [];
                    // let p1 = null;
                    // let p2 = null;
                    if (this.debug) {
                        console.log(' -- getAccess collection:' + col_id + ' role:' + role.id, role.canRulesOrder);
                    }
                    // order is significant
                    if (role.canRulesOrder == 0) {
                        process.push(this.parseAccessSection(this.alwaysArray(role.can), true));
                        process.push(this.parseAccessSection(this.alwaysArray(role.cannot), false));
                        process.push(this.parseAccessSection(this.alwaysArray(role.but_can), true));
                        process.push(this.parseAccessSection(this.alwaysArray(role.but_cannot), false));
                    }
                    else {
                        process.push(this.parseAccessSection(this.alwaysArray(role.cannot), false));
                        process.push(this.parseAccessSection(this.alwaysArray(role.can), true));
                        process.push(this.parseAccessSection(this.alwaysArray(role.but_cannot), false));
                        process.push(this.parseAccessSection(this.alwaysArray(role.but_can), true));
                    }
                    // loop through all rulesets to be processed
                    process.forEach(function (item) {
                        if (this.debug) {
                            console.log('process', item);
                        }
                        // we loop through the returned properties because order is significant
                        for (var r in item) {
                            // just to make sure the property is not something else (shouldn't be needed, but we like to be safe)
                            if (Object.prototype.hasOwnProperty.call(item, r)) {
                                // we loop through the properties again
                                for (var f in item[r]) {
                                    // just to make sure the property is not something else (shouldn't be needed, but we like to be safe)
                                    if (Object.prototype.hasOwnProperty.call(item[r], f)) {
                                        // if ( this.debug ) { console.log ( '!!!', r,f, access ); }
                                        access[f][r] = item[r][f];
                                        access_inv[r][f] = item[r][f];
                                    }
                                }
                            }
                        }
                    }, this);
                }
                else {
                    if (this.debug) {
                        console.log('getAccess collection "' + col_id + '" has no role "' + what_role + '"');
                    }
                }
            }, this);
        }
        // create a cached version
        this.access = access;
        this.access_inv = access_inv;
        // emit a model change here for all subscribers to enjoy
        // disabled with the new Widgets ... this.onAccessModelChange();
        // return the modified object
        return access;
    }
    check(feature, resource) {
        // console.log ( 'ACL check', feature, this.can[feature] );
        if (this.can[feature]) {
            // console.log ( 'ACL check feature pass',feature,resource);
            if (this.can[feature][resource]) {
                // console.log ( 'ACL check feature and resource pass, returning', this.access['feature']['resource'] );
                // if ( this.can[feature][resource] == 'yes' ) {
                return this.can[feature][resource];
                // }
            }
        }
        return false;
    }
    /* helpers */
    // method to ensure an object, string or array is always wrapped in an array, or is the array
    alwaysArray(object) {
        if (!object) {
            return [''];
        }
        return (typeof object === 'string') ? Array(object) : object;
    }
    // handy deep-clone hack as JS only has shallow clones ( ...var or Object.assign({}, var ) )
    deepClone(input) {
        return JSON.parse(JSON.stringify(input));
    }
}
AclService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AclService_Factory() { return new AclService(i0.ɵɵinject(i1.FileDataService)); }, token: AclService, providedIn: "root" });
exports.AclService = AclService;
